import { UrlUtils } from "./urls";

export const LOCATION_PARAM = 'location';
export const CHECK_IN_PARAM = 'checkIn';
export const CHECK_OUT_PARAM = 'checkOut';
export const GUESTS_PARAM = 'guests';

export const RemoveLuxuryHomesParams = () => {
  [LOCATION_PARAM, CHECK_IN_PARAM, CHECK_OUT_PARAM, GUESTS_PARAM].forEach(p => UrlUtils.removeFromUrl(p));
}  